import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UserProfile from "../../../../Component/Normal/UserProfile";

import { formatPhoneNumber } from '../../../../Utils/phoneUtils';
import { useTheme } from '../../../../Context/ThemeContext';
import { useLanguage } from '../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';
import { ReactComponent as PlusSvg } from '../../../../image/Plus.svg';
import { ReactComponent as MinusSvg } from '../../../../image/Minus.svg';

export default function MemberReservationInfoBox(props) {
  const {
    memberData,
    index,
    nowReserveLength,
    maxReserve,
    openChoiceButtonIndex,
    setOpenChoiceButtonIndex,
    onClickMemberProfileOrText,
    onClickAddQueueButton,
    onClickMemberReserveButton
  } = props;

  const { isDark } = useTheme();
  const { languageMode, t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [isViewChoiceAddButton, setIsViewChoiceAddButton] = useState(false);

  useEffect(() => {
    if (isViewChoiceAddButton && openChoiceButtonIndex !== undefined) {
      if (openChoiceButtonIndex !== index) {
        setIsViewChoiceAddButton(false);
      }
    }
  }, [isViewChoiceAddButton, openChoiceButtonIndex, index])

  // 회원 전화번호 표시 //
  function calcPhoneView(phone, countryCode) {
    if (!phone || phone === '') return t('reservation.noPhone');
    return formatPhoneNumber(phone, countryCode, languageMode) || t('reservation.noPhone');
  }

  // 예약 추가 클릭시 //
  function onClickAddReserveButton() {
    if (isViewChoiceAddButton) {
      setOpenChoiceButtonIndex(undefined);
      setIsViewChoiceAddButton(false);
      return;
    }

    if (nowReserveLength < maxReserve) {
      onClickMemberReserveButton(index);
      return;
    }

    setOpenChoiceButtonIndex(index);
    setIsViewChoiceAddButton(true);
  }

  // 예약 인원 초과 후 예약열 추가 클릭시 //
  function onClickAddReserve() {
    onClickMemberReserveButton(index);
    setOpenChoiceButtonIndex(undefined);
    setIsViewChoiceAddButton(false);
  }

  // 예약 인원 초과 후 대기열 추가 클릭시 //
  function onClickAddQueue() {
    onClickAddQueueButton(index);
    setOpenChoiceButtonIndex(undefined);
    setIsViewChoiceAddButton(false);
  }
  return (
    <TotalInfoWrapper key={index}>
      <InfoWrapper>
        <ImageWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
          <UserProfile profile={memberData.profile} defaultProfile='https://picture.link-zone.org/ZoneLogo.png' />
        </ImageWrapper>
        <MemberDataWrapper>
          <TextWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
            <NameWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{memberData.name}</Text>
            </NameWrapper>
            <PhoneWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{calcPhoneView(memberData.phone, memberData.countryCode)}</Text>
            </PhoneWrapper>
          </TextWrapper>
          <PlusButton $isActive={isViewChoiceAddButton} onClick={onClickAddReserveButton}>
            {isViewChoiceAddButton ? <StyledMinus /> : <StyledPlus />}
          </PlusButton>
        </MemberDataWrapper>
      </InfoWrapper>
      <TotalChoiceWrapper isView={isViewChoiceAddButton}>
        <ChoiceAddButtonWrapper>
          <AddButton $full={nowReserveLength < maxReserve} backgroundColor={theme.subKey} onClick={onClickAddReserve}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('reservation.addToReserve')}</Text>
          </AddButton>
          {nowReserveLength >= maxReserve &&
            <AddButton backgroundColor={theme.pointYellow} onClick={onClickAddQueue}>
              <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('reservation.addToQueue')}</Text>
            </AddButton>
          }
        </ChoiceAddButtonWrapper>
      </TotalChoiceWrapper>
    </TotalInfoWrapper>
  );
}
const TotalInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 96%;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-end;

  width: 100%;
  height: 42px;

  gap: 10px;
`;

const TotalChoiceWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  z-index: 1;

  margin-top: -1px;

  width: 100%;
  height: ${props => props.isView ? '37px' : '0px'};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const ChoiceAddButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 37px;

  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  overflow: hidden;
`;

const AddButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.$full ? '100%' : '50%'};
  height: 100%;

  background-color: ${props => props.backgroundColor};

  &:hover {
    cursor: pointer;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 3px;

  overflow: hidden;

  & img {
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
  }

  &:hover {
    cursor: pointer;
  }
`;

const MemberDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: calc(100% - 32px);
  height: 42px;

  border-bottom: 1px solid ${props => props.theme.line};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  min-width: 0;
  flex: 1;

  margin-bottom: 4px;

  &:hover {
    cursor: pointer;
  }
`;

const NameWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PhoneWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PlusButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const StyledPlus = styled(PlusSvg)`
  flex-shrink: 0;
  width: 17px;
  height: auto;

  & path {
    fill: ${props => props.theme.subKey};
  }

  transition: all 0.3s ease-in-out;
`;

const StyledMinus = styled(MinusSvg)`
  flex-shrink: 0;
  width: 25px;
  height: auto;

  & path {
    fill: ${props => props.theme.pointRed};
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
